module.exports = __webpack_public_path__ + "static/media/life-overview-banner-desktop.d38165e4.jpg";